module.exports = __webpack_public_path__ + "media/images/icons/mobile-29c21978f1bc30f19aea2d90b1e5c117.svg";